import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Switch } from '@inplayer-org/inplayer-ui';

// hooks
import useBoolean from 'hooks/useBoolean';
import useSharedBoolean from 'pages/MerchantPages/Assets/containers/EditAsset/hooks/useSharedBoolean';

// actions
import { loadBranding } from 'ducks/merchantDucks/branding/actions';

// selectors
import { getBranding } from 'ducks/merchantDucks/branding/selectors';
import { getAuthState } from 'ducks/merchantDucks/user/selectors';

const ItemPreviewDefaultBrandingTheme: FC = () => {
  const dispatch = useDispatch();

  const isPreviewDefaultBranding = useBoolean(false);
  const [useDefaultBrandingTheme, setUseDefaultBrandingTheme] = useSharedBoolean('useDefaultBrandingTheme');
  const [isAnalyticsView] = useSharedBoolean('isAnalyticsView');

  const { defaultBrandingSet } = useSelector(getBranding);
  const {
    user: { tenant_uuid: tenantUuid },
  } = useSelector(getAuthState);

  useEffect(() => {
    dispatch(loadBranding(tenantUuid));
  }, []);

  useEffect(() => {
    isPreviewDefaultBranding.setValue(!!useDefaultBrandingTheme);
  }, [useDefaultBrandingTheme]);

  const onDefaultBrandingSwitchChange = (checked: boolean) => {
    if (setUseDefaultBrandingTheme) {
      setUseDefaultBrandingTheme(checked);
      isPreviewDefaultBranding.setValue(checked);
    }
  };

  if (defaultBrandingSet && !isAnalyticsView) {
    return (
      <Tooltip content="See what the default branding theme looks like." placement="bottom">
        <Switch
          tag="toggle_preview"
          checked={isPreviewDefaultBranding.value}
          id="default branding theme"
          label="Preview default branding theme"
          onChange={onDefaultBrandingSwitchChange}
        />
      </Tooltip>
    );
  }

  return null;
};

export default ItemPreviewDefaultBrandingTheme;
